module.exports = __webpack_public_path__ + "img/cary-with-keyboard.f3745c63.png";